/** Safely format a number-like value (string or number) to fixed decimals */
export function toFixed(value: unknown, decimals = 2): string {
  return Number(value || 0).toFixed(decimals);
}

/** Format as EUR amount */
export function formatEUR(value: unknown): string {
  return `${toFixed(value, 2)} EUR`;
}
